import React from 'react';
import Helmet from 'react-helmet';
import Layout from '../layouts';
import WebsiteTerms from '../components/WebsiteTerms';

class Terms extends React.Component {
  render() {
    return (
      <Layout location={this.props.location}>
        <Helmet titleTemplate={false}>
          <title>Website Terms of Use | Paperform</title>
          <meta name="description" content="Paperform website terms of use." />
          <meta
            property="og:title"
            content="Website Terms of Use | Paperform"
          />
          <meta
            property="og:description"
            content="Paperform website terms of use"
          />
        </Helmet>
        <div className="post-full-header">
          <h1 className="blog-post-title">Website Terms Of Use</h1>
        </div>

        <div className="blog-post">
          <WebsiteTerms />
        </div>
      </Layout>
    );
  }
}

export default Terms;
